import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      hasInitiated: false,
      transitionName: null
    };
  },

  computed: {
    ...mapGetters('merchant', ['merchant']),
    ...mapGetters('session', ['currentUser']),

    isMerchantLoading() {
      return [
        !this.hasInitiated,
        this.merchant.isLoading,
        this.currentUser.isLoading
      ].some(Boolean);
    }
  },

  methods: {
    async initializeMerchant(orderConfig) {
      await this.$store.dispatch('socket/initialize');

      await this.$store.dispatch('session/load');

      // Only normalize orders if config is provided
      if (orderConfig) {
        this.$store.dispatch('orders/normalizeOrderDetails', orderConfig);
      }

      this.$router.beforeEach(this.routerBeforeEach);

      setTimeout(() => {
        /*
          NOTE: This delay is necessary to allow our Vuex actions to initiate and
          update loading states before attempting to render components (<router-view>).
          Otherwise, components will be rendered twice (once on app start, and again when
          loading states resolve).
        */

        this.hasInitiated = true;
      }, 25);
    },

    routerBeforeEach(to, from, next) {
      if (to.name === 'payAtTableReceipt') {
        this.transitionName = 'slide-to-right';
      }
      else {
        this.transitionName = null;
      }

      next();
    },

    destroyedMerchantHandler() {
      // Cleanup logic if needed in the future
      // Currently no event listeners to remove like in order-ahead
    }
  }
};
